import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";

const schema: any = {
  required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  maxLength: {
    value: 85,
    message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
  },
};

export { schema };
